import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant41() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      title1: 'Сделаем сайт для вас бесплатно.',
      title2: `Обслуживание — ${price}/мес.`,
      sub: `Мы делаем сайт за свой счёт. Вы смотрите, просите правки, утверждаете. Когда всё нравится — платите ${price} в месяц за хостинг и поддержку. Не понравится — просто уходите. Без оплаты.`,
      cta: 'Начать проект'
    },
    ua: {
      title1: 'Зробимо сайт для вас безкоштовно.',
      title2: `Обслуговування — ${price}/міс.`,
      sub: `Ми робимо сайт за свій рахунок. Ви дивитеся, просите правки, затверджуєте. Коли все подобається — платите ${price} на місяць за хостинг та підтримку. Не сподобається — просто йдете. Без оплати.`,
      cta: 'Почати проєкт'
    },
    en: {
      title1: 'We build your website for free.',
      title2: `Maintenance — ${price}/mo.`,
      sub: `We build the site at our expense. You review, request edits, and approve. When you love it, you pay ${price}/month for hosting and support. Don't like it? Just walk away. No charge.`,
      cta: 'Start project'
    }
  }[language] || content.ru;
  return <>
      <section className="relative w-full pt-28 pb-12 px-4 flex items-center justify-center min-h-screen" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-652">
        {/* Full Rounded Video Container */}
        <div className="relative w-full max-w-[96%] h-[85vh] rounded-[2.5rem] overflow-hidden shadow-2xl flex items-center" data-id="element-653">
          <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-654" />

          {/* Vignette Gradient Overlay */}
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/60 to-transparent" data-id="element-655" />

          {/* Left-Aligned Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="relative z-10 p-8 md:p-16 max-w-3xl" data-id="element-656">
            <h1 className="mb-4 text-4xl md:text-6xl lg:text-7xl font-black leading-[1.1] text-white tracking-tight" data-id="element-657">
              {content.title1}
            </h1>
            <h2 className="mb-8 text-2xl md:text-4xl font-bold text-blue-400" data-id="element-658">
              {content.title2}
            </h2>
            <p className="text-lg md:text-xl mb-10 text-gray-300 font-medium leading-relaxed max-w-xl" data-id="element-659">
              {content.sub}
            </p>
            <button onClick={() => setIsPopupOpen(true)} className="group inline-flex items-center justify-center gap-2 rounded-2xl px-8 py-4 font-bold text-lg transition-all hover:scale-105 bg-blue-600 text-white hover:bg-blue-500" data-id="element-660">
              {content.cta}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-661" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-662" />
    </>;
}